/**
 * Download Center - Data Definitions
 */

const searchFormValue = {
    status: null,
    filename: null,
    fromDate: null,
    toDate: null,
    includeOthers: false,
};

const statusOptions = [
    { text: '전체', value: null },
    { text: '대기', value: 'ready' },
    { text: '처리중', value: 'processing' },
    { text: '완료', value: 'completed' },
    { text: '실패', value: 'failed' },
];



// Size warning threshold: 500MB
const SIZE_WARNING_THRESHOLD = 500 * 1024 * 1024;

export { searchFormValue, statusOptions, SIZE_WARNING_THRESHOLD };

